module.exports = __webpack_public_path__ + "static/visionar_augmented_reality_metaverse-b4fc0ef4676fd0e926e521ac779b7431.png";